<template>
  <div class="progslide">
    <div class="progslide__name">{{name}}</div>
    <div class="progslide__content">
      <div class="progslide__icon" v-html="icon"></div>
      <div class="progslide__text">
        <div class="progslide__title">Максимальное страховое&nbsp;покрытие</div>
        <div class="progslide__price" v-html="price"></div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      name: String,
      price: String,
      icon: String
    }
  }
</script>

<style lang="sass">
.progslide
  &__name
    text-align: center
    font-weight: 500
    font-size: 20px
    line-height: 1.18
    color: colors.$bluefont2
    margin-bottom: 14px
  &__content
    display: flex
    justify-content: center
    align-items: center
  &__icon
    margin-right: 32px
    svg
      display: block
  &__title
    margin-top: 2px
    font-size: 14px
    line-height: 1.14
    max-width: 140px
    color: colors.$bluefont5b
    margin-bottom: 8px
  &__price
    font-weight: 500
    font-size: 20px
    line-height: 1.18
    color: colors.$bluefont2
</style>